export * from './app.component';
export * from './app.module';



// WEBPACK FOOTER //
// /home/backend/NasheDelo/WebLombard/client/src/app/index.ts